module.exports = __webpack_public_path__ + "img/29.6d908991.png";